var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./SessionWatcher.jinja');
require('./SessionWatcher.less');

module.exports = Backbone.View.extend({

    el: '.SessionWatcher',

    template: template,

    WARNING_DELAY: 10 * 60, //10min - delay (in seconds) before session will expire to show warning popup

    events: {
        'click .SessionWatcher-buttons-button--first': 'onFirstButtonClick',
        'click .SessionWatcher-buttons-button--second': 'onSecondButtonClick'
    },

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onPageVisibilityChange');

        if (window.app.settings.member) {
            this.pingSession();

            app.utils.PageVisibilityManager.addEventListener(this.onPageVisibilityChange);
        }
    },

    pingSession: function() {
        clearTimeout(this.showPopupTimeout);
        clearTimeout(this.showLogoutPopupTimeout);

        this.pingXhr && this.pingXhr.abort();

        this.pingXhr = $.ajax({
            url: Urls['front:api:my_adg_session_ping'](),
            method: 'GET',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (responseData) {
                console.log('time to session expire: ', responseData.timeLeft + 's');
                if (responseData.timeLeft > this.WARNING_DELAY) {
                    this.showPopupTimeout = setTimeout(function() {
                        this.showPopup('warning', this.WARNING_DELAY);
                    }.bind(this), (responseData.timeLeft - this.WARNING_DELAY) * 1000);
                } else {
                    this.showPopup('warning', responseData.timeLeft);
                }
            },
            error: function (e, tp) {
                //session expired
                if (e.status == 400) {
                    this.showPopup('logout');
                }
            },
            context: this
        });
    },


    onPageVisibilityChange: function() {
        if (!app.utils.PageVisibilityManager.isPageHidden()) {
            this.pingSession();
        }
    },


    onFirstButtonClick: function() {
        if (this.tp == 'warning') { //stay logged in
            this.extendXhr && this.extendXhr.abort();

            var $button = this.$('.SessionWatcher-buttons-button--first');

            $button.addClass('Button--loading');

            this.extendXhr = $.ajax({
                url: Urls['front:api:my_adg_session_extend'](),
                method: 'GET',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                success: function (responseData) {
                    console.log(responseData);
                    $button.removeClass('Button--loading');
                    this.$el.removeClass('visible');
                    clearTimeout(this.showLogoutPopupTimeout);
                    this.pingSession();
                },
                error: function (e, tp) {
                    alert('Something went wrong, try again later.');
                    $button.removeClass('Button--loading');
                    console.log(e, tp);
                },
                context: this
            });
        }

        if (this.tp == 'logout') { //Login
            window.location.href = Urls['front:login-popup']();
        }
    },


    onSecondButtonClick: function() {
        if (this.tp == 'warning') { //Log out, and go to homepage
            window.app.vent.trigger('make-logout');

        }

        if (this.tp == 'logout') { //close, go to homepage
            window.location.href = Urls['front:index']();
        }
    },


    showPopup: function(tp, logoutDelay) {
        this.$el.addClass('visible');

        this.tp = tp;

        if (tp == 'warning') {
            this.$('.SessionWatcher-text').text('Your session is about to expire and you will be logged out from the site');
            this.$('.SessionWatcher-buttons-button--first').text('Stay Logged In');
            this.$('.SessionWatcher-buttons-button--second').text('Log out');
        } else {
            this.$('.SessionWatcher-text').text('Your session now expired and you are no longer logged in');
            this.$('.SessionWatcher-buttons-button--first').text('Login');
            this.$('.SessionWatcher-buttons-button--second').text('Close');
        }

        clearTimeout(this.showLogoutPopupTimeout);

        if (tp == 'warning') {
            this.showLogoutPopupTimeout = setTimeout(function() {
                this.showPopup('logout');
            }.bind(this), logoutDelay * 1000 + 1000); //+1s for safety
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/SessionWatcher/SessionWatcher.js
// module id = 248
// module chunks = 0